export default {
  agency_id: '01JJ2KRHAHXFA5GN91VHSD6XGZ',

  topbar: [
    {
      name: 'campaigns',
      classIcon: 'mdi mdi-bullhorn',
      to: '/campaigns',
      slug: 'campaigns',
    },
    {
      name: 'templates',
      classIcon: 'mdi mdi-view-dashboard',
      to: '/templates',
      slug: 'templates',
    },
    {
      name: 'analytics',
      classIcon: 'mdi mdi-chart-bar',
      to: '/analytics',
      slug: 'analytics',
    },
  ],
}
